import FtpeMasqueToggle from '../../components/FtpeMasqueToggle';
import React from 'react';
export default function ResultatsMontants({
  resultat, modeCalcul, modeSimulateur, user, formData,
  contratParent, walletBalance, creditCostPdf, hasEnoughCredits, loadingDevis,
  handleDownloadDevisSimulation, handleSouscrire, handleCreerAvenant, propositionConversion, handleSouscrireFromProposition,
  dismissPropositionConversion, isFtpeMember, loading, selectedActivitesPIB = [], selectedActivitesGO = [],
  selectedActivites2nd = [], selectedActivitesTP = [], montantsPersonnalises, setMontantsPersonnalises, getMontantsFinals,
  getTaxesFinals, taxesPersonnalisees, setTaxesPersonnalisees, isSuperAdmin, isAdminOrSuperAdmin,
  validitePersonnalisee, setValiditePersonnalisee, updateLigneTaxe, supprimerLigneTaxe, ajouterLigneTaxe,
  remiseSolidaireNegociee = null, onEcheancierPlanChange = null, signatureModalOpen, setSignatureModalOpen}) {
  return (
    <>
                    <div className="space-y-2 text-sm">
                      <div id="montant-ht-result" className="flex justify-between p-2 bg-blue-50 rounded-lg border border-blue-200">
                        <span className="text-slate-700 font-medium">
                          Montant de base de la contribution solidaire
                          {montantsPersonnalises.enabled && getMontantsFinals()?.is_personnalise && (
                            <span className="ml-2 text-xs text-emerald-600 font-normal">(personnalisé)</span>
                          )}
                        </span>
                        <span className="font-bold text-blue-700">
                          {(montantsPersonnalises.enabled && getMontantsFinals()?.montant_ht) 
                            ? getMontantsFinals().montant_ht.toLocaleString('fr-FR', {maximumFractionDigits: 2})
                            : resultat.montant_ht?.toLocaleString('fr-FR')} €
                        </span>
                      </div>
                      
                      {/* Affichage de la remise si applicable */}
                      {montantsPersonnalises.enabled && getMontantsFinals()?.remise > 0 && (
                        <div className="flex justify-between p-2 bg-red-50 rounded-lg border border-red-200">
                          <span className="text-red-700 font-medium">Remise appliquée</span>
                          <span className="font-bold text-red-600">-{getMontantsFinals().remise}%</span>
                        </div>
                      )}

                      {resultat.detail_calcul?.rcd_solidaire_gros_oeuvre > 0 && (
                        <div className="flex justify-between pl-4 text-xs">
                          <span className="text-slate-500">• RCD Solidaire Gros Œuvre</span>
                          <span>{resultat.detail_calcul.rcd_solidaire_gros_oeuvre?.toLocaleString('fr-FR')} €</span>
                        </div>
                      )}

                      {resultat.detail_calcul?.rcd_solidaire_second_oeuvre > 0 && (
                        <div className="flex justify-between pl-4 text-xs">
                          <span className="text-slate-500">• RCD Solidaire Second Œuvre</span>
                          <span>{resultat.detail_calcul.rcd_solidaire_second_oeuvre?.toLocaleString('fr-FR')} €</span>
                        </div>
                      )}

                      {resultat.detail_calcul?.rcd_solidaire_pib_net > 0 && (
                        <div className="flex justify-between pl-4 text-xs">
                          <span className="text-slate-500">• RCD Solidaire PIB {resultat.detail_calcul.remise_pib > 0 ? '(avec remise)' : ''}</span>
                          <span className={resultat.detail_calcul.remise_pib > 0 ? "text-green-600" : ""}>
                            {resultat.detail_calcul.rcd_solidaire_pib_net?.toLocaleString('fr-FR')} €
                          </span>
                        </div>
                      )}

                      {resultat.detail_calcul?.rcd_solidaire_travaux_publics > 0 && (
                        <div className="flex justify-between pl-4 text-xs">
                          <span className="text-slate-500">• RCD Solidaire Travaux Publics</span>
                          <span>{resultat.detail_calcul.rcd_solidaire_travaux_publics?.toLocaleString('fr-FR')} €</span>
                        </div>
                      )}
                      
                      {resultat.detail_calcul?.note && (
                        <div className="mt-2 p-2 bg-blue-50 rounded text-xs text-blue-700">
                          ℹ️ {resultat.detail_calcul.note}
                        </div>
                      )}
                    </div>

                    <div className="border-t pt-3 space-y-2 text-sm">
                      <h5 className="font-semibold text-xs text-slate-700">
                        Contributions solidaires
                        {taxesPersonnalisees.enabled && (
                          <span className="ml-2 text-xs text-purple-600 font-normal">(personnalisé)</span>
                        )}
                      </h5>
                      {taxesPersonnalisees.enabled && getTaxesFinals()?.detail ? (
                        // Taxes personnalisées par Super Admin (montants uniquement)
                        getTaxesFinals().detail.map((taxe, index) => (
                          <div key={index} className="flex justify-between text-xs">
                            <span className="text-slate-500">{taxe.nom}</span>
                            <span className="font-medium text-purple-700">{taxe.montant?.toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €</span>
                          </div>
                        ))
                      ) : resultat.taxes?.detail ? (
                        // Nouveau format avec taxes configurées (montants uniquement)
                        resultat.taxes.detail.map((taxe, index) => (
                          <div key={index} className="flex justify-between text-xs">
                            <span className="text-slate-500">{taxe.nom}</span>
                            <span>{taxe.montant?.toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €</span>
                          </div>
                        ))
                      ) : taxesPersonnalisees.lignes?.length > 0 ? (
                        // Fallback: utiliser les taxes chargées depuis config
                        taxesPersonnalisees.lignes.filter(t => t.actif).map((taxe, index) => (
                          <div key={index} className="flex justify-between text-xs">
                            <span className="text-slate-500">{taxe.nom}</span>
                            <span>{((resultat.montant_ht || 0) * (taxe.taux / 100)).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €</span>
                          </div>
                        ))
                      ) : (
                        // Fallback ultime si rien n'est configuré
                        <div className="text-xs text-slate-400 italic">Contributions non configurées</div>
                      )}
                    </div>

                    {resultat.periode && (
                      <div className="border-t pt-3 space-y-2 text-sm bg-blue-50 p-3 rounded">
                        <div className="flex justify-between">
                          <span className="text-slate-600">Montant journalier</span>
                          <span className="font-medium">{resultat.periode.montant_journalier?.toLocaleString('fr-FR')} €</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-slate-600">Période ({resultat.periode.nombre_jours} jours)</span>
                          <span className="font-medium">{resultat.periode.montant_periode?.toLocaleString('fr-FR')} €</span>
                        </div>
                      </div>
                    )}

                    <div className="mt-3"><FtpeMasqueToggle /></div>
                    {/* Bloc Adhésion partenaire FTPE - uniquement si non adhérent */}
                    {!isFtpeMember && (
                      <div className="border-t pt-3 mt-3 space-y-3">
                        <div className="p-3 rounded-lg border-l-4 border-blue-700 bg-blue-200" data-testid="batico-ftpe-adhesion-block">
                          <div className="text-xs font-bold text-blue-900 uppercase mb-2">Adhésion partenaire</div>
                          <div className="flex justify-between items-center text-sm">
                            <span className="text-gray-800">Cotisation annuelle FTPE</span>
                            <span className="font-bold text-blue-900">200,00 €</span>
                          </div>
                          <p className="text-xs text-gray-700 italic mt-2">
                            Paiement direct à la FTPE — (COPPAM – programme hébergé par O'SCOP – n'encaisse pas cette cotisation)
                          </p>
                        </div>

                        <div className="p-3 rounded-lg bg-gradient-to-r from-indigo-900 to-indigo-800 text-white" data-testid="batico-ftpe-total-block">
                          <div className="flex justify-between items-center">
                            <span className="text-xs font-bold uppercase">Total indicatif du parcours coopératif</span>
                            <span className="text-lg font-bold">
                              {(((montantsPersonnalises.enabled && getMontantsFinals()?.montant_ttc) ? getMontantsFinals().montant_ttc : (resultat.montant_ttc || 0)) + 200).toLocaleString('fr-FR', {maximumFractionDigits: 2})} €
                            </span>
                          </div>
                          <div className="text-xs opacity-80 mt-1">
                            (Montant Global {((montantsPersonnalises.enabled && getMontantsFinals()?.montant_ttc) ? getMontantsFinals().montant_ttc : (resultat.montant_ttc || 0)).toLocaleString('fr-FR', {maximumFractionDigits: 2})} € + Cotisation FTPE 200,00 €)
                          </div>
                        </div>
                      </div>
                    )}

    </>
  );
}
